"use client";

import { Card, CardBody, CardFooter } from "@heroui/card";
import { Chip } from "@heroui/chip";
import Title from "@/components/title";
import Link from "next/link";

interface GlossaryTerm {
  id: string;
  term: string;
  category: string;
  definition: string;
  relatedTerms: string[];
}

interface GlossaryCardProps {
  term: GlossaryTerm;
}

const categoryColors: Record<string, string> = {
  Genre: "bg-accent/10 text-accent",
  Production: "bg-status-special/10 text-status-special",
  Culture: "bg-status-positive/10 text-status-positive",
  "DJ Technique": "bg-status-warning/10 text-status-warning",
  "Song Structure": "bg-status-special/10 text-status-special",
  "Sound Design": "bg-status-info/10 text-status-info",
  "Audio Effect": "bg-status-special/10 text-status-special",
  Rhythm: "bg-status-warning/10 text-status-warning",
  Event: "bg-status-positive/10 text-status-positive",
  "Rave Culture": "bg-status-positive/10 text-status-positive",
};

export default function GlossaryCard({ term }: GlossaryCardProps) {
  return (
    <Link href={`/glossary/${term.id}`}>
      <Card
        isPressable
        className="bg-surface/50 border border-line hover:border-line-strong transition-all duration-300 group h-full"
        id={term.id}
      >
        <CardBody className="p-6">
          <div className="flex items-start justify-between mb-3">
            <Title
              level={3}
              size="xl"
              weight="bold"
              className="text-ink group-hover:text-theme-light transition-colors"
            >
              {term.term}
            </Title>
            <Chip
              color="default"
              variant="flat"
              size="sm"
              className={`ml-2 ${categoryColors[term.category] || "bg-surface-hover text-ink-secondary"}`}
            >
              {term.category}
            </Chip>
          </div>
          <p className="text-ink-secondary text-sm leading-relaxed mb-4 line-clamp-3">
            {term.definition}
          </p>
          <div className="flex items-center gap-2 text-theme-light text-sm font-medium group-hover:gap-3 transition-all">
            <span>Read more</span>
            <svg
              className="w-4 h-4 group-hover:translate-x-1 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </CardBody>
        {/* {term.relatedTerms.length > 0 && (
          <CardFooter className="px-6 pb-6 pt-0">
            <div className="w-full">
              <p className="text-xs text-subtle mb-2">Related Terms:</p>
              <div className="flex flex-wrap gap-2">
                {term.relatedTerms.slice(0, 3).map((relatedTerm) => (
                  <span
                    key={relatedTerm}
                    className="text-xs px-2 py-1 bg-surface-raised rounded-full text-muted"
                  >
                    {relatedTerm}
                  </span>
                ))}
                {term.relatedTerms.length > 3 && (
                  <span className="text-xs px-2 py-1 text-subtle">
                    +{term.relatedTerms.length - 3} more
                  </span>
                )}
              </div>
            </div>
          </CardFooter>
        )} */}
      </Card>
    </Link>
  );
}
